/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { Injectable, NgZone } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { Router } from '@angular/router';
import firebase from 'firebase/app';
import { BehaviorSubject, Observable, of, ReplaySubject, Subject, timer } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';

import '@firebase/auth';

import { AlertService } from './alert.service';
import { environment } from 'src/environments/environment';
import { firebaseProvider } from '../enums/firebaseProvider';
import { resourcesImages, URL_ASSETS } from '../consts';
import { AuthCookieService } from './cookies.service';
import { DistrictShort } from '../graphql';
import { Subscription } from 'rxjs/internal/Subscription';
import { AngularFirestore } from '@angular/fire/firestore';
import { CookieTkService } from './cookie.tk.service';
import * as jose from 'jose';
import { first } from 'rxjs/operators';
import { SessionUserV2Service } from './session-user.service';
import { MsalService } from '@azure/msal-angular';
import { loginRequest } from '../consts/msal-config';
import { NycAuthService } from './nyc.auth.service';
import { MicrosoftErrorService } from './microsoft.error.service';

const userTrialEmail = environment.userNameTrial;
const networkError = 'Unable to connect to authentication provider, try again later or contact your provider.';
const credentialError = 'This email is already associated with another account. Please try signing in with the method you originally used, or reset your password if needed.';

declare var sessionStorage: any;
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  userData: any;
  currentProvider!: firebaseProvider;

  private loginFailed$ = new ReplaySubject<boolean>();
  public loginFailed = this.loginFailed$.asObservable();
  private authToken$ = new ReplaySubject<string>();
  public authToken = this.authToken$.asObservable();
  private authUser$ = new ReplaySubject<any>();
  public authUser = this.authUser$.asObservable();

  private authStateSubs!: Subscription;
  private idTokenSubs!: Subscription;
  loadingTkCookie!: boolean | undefined;
  token!: string;
  private refreshTokenWorker!: Worker;
  private authChannel = new BroadcastChannel('auth-channel');
  private leaderCheckInterval: any;
  private readonly LEADER_KEY = 'auth_refresh_leader';

  private tokenSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
  public token$: Observable<string | null> = this.tokenSubject.asObservable();
  private existEmptyProvider$ = new Subject<firebaseProvider>();
  public existEmptyProvider = this.existEmptyProvider$.asObservable();


  constructor(public afs: AngularFirestore, public afAuth: AngularFireAuth, public router: Router, public ngZone: NgZone,
    private alertService: AlertService, private matDialog: MatDialog, private cookieTkService: CookieTkService,
    private authCookiesServ: AuthCookieService, private sessionUserV2Service: SessionUserV2Service,
    private msalService: MsalService, private nycAuthService: NycAuthService,
    private microsoftErrorService: MicrosoftErrorService,
  ) {
    /* Saving user data in localstorage when
     logged in and setting up null when logged out */
    this.authStateSubs = this.afAuth.authState.subscribe((user: any) => {
      if (user?.email === userTrialEmail) { return; }
      if (user) {
        if (user._lat) {
          this.token = user._lat;
        }
        this.userData = user;
        this.tokenSubject.next(this.token);
        sessionStorage.setItem('user', JSON.stringify(this.userData));
        const fromDemo = this.authCookiesServ.getAuth('userId') && this.authCookiesServ.getAuth('userId') !== '';
        const isTrialRegister = this.router.url?.includes('register');
        const isStarted = this.router.url?.includes('started');
        const origin = sessionStorage.getItem('origin');
        this.setUserData(this.userData, Boolean(fromDemo) || isTrialRegister || isStarted || origin == 'admin');
      } else {
        sessionStorage.setItem('user', '');
      }
    });

    this.listenBroadcastChannel();
    this.checkIfLeader();
  }


  getTkApi(token: string, tkMicrosoft?: string): Promise<any> {
    return new Promise((resolve) => {
      this.loadingTkCookie = true;
      this.cookieTkService.setCookie(token, tkMicrosoft).subscribe(
        () => {
          console.log('Success setting cookie');
          this.loadingTkCookie = false;
          resolve(token);
        },
        error => {
          this.loadingTkCookie = false;
          resolve(false);
          console.error('Error setting cookie', error);
        }
      );
    });
  }

  /**
   * Signs in to Firebase using a custom token generated by the backend.
   * Resolves with the user on success, or false on failure.
   */
  authCustomTokenMsal(customToken: string): Promise<any> {
    return new Promise((resolve) => {
      this.afAuth.signInWithCustomToken(customToken)
        .then((userCredential) => {
          resolve(userCredential?.user);
        })
        .catch(() => {
          resolve(false);
        });
    });
  }


  /* Sign up - Tested */
  public signUp = (email: string, password: string) => {
    this.afAuth.createUserWithEmailAndPassword(email, password)
      .then((result) => {
        this.setUserData(result.user, true);
      }).catch((error) => {
        this.alertService.error(error.message, 'Authentication error');
      });
  }
  // Sign in with email/password
  public signIn = (email: string, password: string) => {
    return this.afAuth.signInWithEmailAndPassword(email, password)
      .then((result) => {
        this.setUserData(result.user);
        this.setLoginFailed(false);
      }).catch((error) => {
        this.alertService.error(error.message, 'Authentication error');
        this.setLoginFailed(true);
      });
  }

  getUserPhotoURL(user?: any): string {
    const photoURL = user?.photoURL ? user.photoURL :
      user?.providerData?.length > 0 && user.providerData[0].photoURL ? user.providerData[0].photoURL :
        URL_ASSETS + resourcesImages['blank-profile'];
    return photoURL;
  }

  /* Setting up user data when sign in with username/password,
    sign up with username/password and sign in with social auth
    provider in Firestore database using AngularFirestore + AngularFirestoreDocument service */
  setUserData(user: any, signup?: boolean): void {
    const comesFromLti = sessionStorage.getItem('origin') === 'lti';
    const userData = {
      uid: user.uid,
      email: user.email,
      displayName: user.displayName,
      photoURL: this.getUserPhotoURL(user),
      emailVerified: user.emailVerified
    };

    this.idTokenSubs = this.afAuth.idToken.subscribe(async (token) => {
      if (token) {
        this.token = token;
        this.resolveUserCallback(userData, token);
      }
    });

  }

  setSessionActive(session: boolean): void {
    sessionStorage.setItem('sessionActive', session);
  }

  getSessionActive(): boolean {
    return sessionStorage.getItem('sessionActive');
  }


  setUserDataPromise(user: any, tk?: string, tkMicrosoft?: string): Promise<any> {
    return new Promise((resolve) => {
      const userData = {
        uid: user.uid,
        email: user.email,
        displayName: user.displayName,
        photoURL: this.getUserPhotoURL(user),
        emailVerified: user.emailVerified
      };
      this.idTokenSubs = this.afAuth.idToken.subscribe(async (token) => {
        const tkAux = token || tk;
        this.getTkApi(tkAux as string, tkMicrosoft).then((tk) => {
          if (tk) {
            this.resolveUserCallback(userData, tkAux as string);
            resolve(userData);
            this.startRefreshTokenTimer();
          }
        });
        if (this.idTokenSubs) {
          this.idTokenSubs.unsubscribe();
        }
      });
    });
  }

  private resolveUserCallback(userData: any, token: string | null): void {
    if (token) {
      this.token = token;
    }
    this.setToken(token);
    sessionStorage.setItem('user', JSON.stringify(userData));
    this.setLoginFailed(false);
    this.setUser(userData);
  }

  // Returns true when user is looged in and email is verified
  get isLoggedIn(): boolean {
    const user = JSON.parse(JSON.stringify(sessionStorage.getItem('user')));
    return (user && user !== 'null' && user.emailVerified !== false) ? true : false;
  }

  get isAnonymous(): boolean {
    const user = JSON.parse(sessionStorage.getItem('user'));
    return (user && user.email !== 'null') ? true : false;
  }
  // Sign in with Google
  googleAuth = (signup?: boolean) => {
    const provider = new firebase.auth.GoogleAuthProvider();
    provider.setCustomParameters({
      prompt: 'select_account'
    });
    return this.authLogin(provider, signup);
  }

  authLoginPromise = (isMicrosoft?: boolean): Promise<boolean> => {
    return new Promise((resolve) => {
      const provider = isMicrosoft ? new firebase.auth.OAuthProvider(firebaseProvider.Microsoft) : new firebase.auth.GoogleAuthProvider();
      provider.setCustomParameters({
        prompt: 'select_account'
      });
      return this.afAuth.signInWithPopup(provider)
        .then((result) => {
          this.setUserDataPromise(result.user).then((value: boolean) => {
            resolve(value);
          });
        }).catch((error) => {
          resolve(false);
          this.showErrorMessage(error);
        });
    });
  }

  classLinkAuth = () => {
    const provider = new firebase.auth.OAuthProvider(firebaseProvider.ClassLink);
    provider.setCustomParameters({
      prompt: 'select_account',
    });
    return this.oauthLogin(provider, true);
  }

  // Sign in with Microsoft
  microsoftAuth = (signup?: boolean) => {
    const provider = new firebase.auth.OAuthProvider(firebaseProvider.Microsoft);
    provider.setCustomParameters({
      prompt: 'select_account',
    });
    return this.oauthLogin(provider, signup);
  }

  // Auth logic to run auth providers
  authLogin = (provider: any, signup?: boolean) => {
    return this.afAuth.signInWithPopup(provider)
      .then((result) => {
        this.setUserData(result.user);
      }).catch((error) => {
        this.showErrorMessage(error);
      });
  }

  signInAnonymously(): Promise<any> {
    return this.afAuth.signInAnonymously();
  }

  signInWithRedirect = (provider: any): Promise<void> => {
    provider.setCustomParameters({
      prompt: 'select_account'
    });
    return this.afAuth.signInWithRedirect(provider);
  }

  showErrorMessage(error: any): void {
    const isNetworkError = error?.message?.includes('network error');
    const rawMsg = isNetworkError ? networkError : error?.message;

    const msError = this.microsoftErrorService.sanitize(rawMsg);

    if (msError) {
      this.alertService.error(msError.message, msError.title);
    } else {
      this.alertService.error(rawMsg, 'Authentication error');
    }

    this.setLoginFailed(true);
  }

  oauthLogin = (provider: any, signup?: boolean) => {
    return this.afAuth.signInWithPopup(provider)
      .then((result) => {
        this.setUserData(result.user);
      }).catch((error) => {
        if (error.email && error.credential && error.code === 'auth/account-exists-with-different-credential') {
          this.fetchSignInMethodsForEmail(error, signup);
        } else if (error.message.includes("error_description=AADSTS65004")) {
          this.setLoginFailed(true);
        } else {
          this.showErrorMessage(error);
        }
      });
  }
  // Firebase SignInWithPopup
  oAuthProvider = (provider: any) => {
    return this.afAuth.signInWithPopup(provider).catch((error) => {
      return error;
    });
  }

  fetchSignInMethodsForEmail = async (error: any, signup?: boolean, providerAttempt?: firebaseProvider | null): Promise<void> => {
    try {
      const providers = await firebase.auth().fetchSignInMethodsForEmail(error.email);

      if (providers && Array.isArray(providers)) {

        const currentUser = await this.afAuth.authState.pipe(first()).toPromise();

        if (!currentUser) {
          if (providerAttempt === firebaseProvider.Microsoft) {
            localStorage.setItem('userFirstLinking', error.email);
            this.existEmptyProvider$.next(firebaseProvider.Microsoft);
          } else {
            this.alertService.error(error, 'Authentication error');
            this.setLoginFailed(true);
          }
          return;
        }
        try {
          await currentUser.linkWithCredential(error.credential);
          this.setUserDataPromise(currentUser).then((value: boolean): any => {
            if (value) {
              return this.router.navigate(['/']);
            }
          });
          } catch (linkError: any) {
              const errorCode = linkError.code;  
              if (errorCode === 'auth/invalid-credential') {
                  this.alertService.error('The account linking process has timed out. Please try again.', 'Authentication error');
              } else {
                if (linkError.code === 'auth/requires-recent-login') {
                    const errorMessage = 
                          'For security reasons, your current login session is too old ' +
                          'to link a new account. You need to sign out and sign in again ' +
                          'to refresh your security credentials.';
                        
                    this.alertService.error(errorMessage, 'Security Timeout');
                } else {
                    let errorMessage = linkError instanceof Error ? linkError.message : 'Unknown linking error';
                    errorMessage = errorMessage + '.Please try signing in again.'
                    this.alertService.error(errorMessage, 'Authentication error');
                }
              }
    
              this.setLoginFailed(true);
              timer(2500).subscribe(()=>{
                this.signOut();
              });
        }
      } else {
        // No existing providers - handle new user case if needed
        this.alertService.error(credentialError, 'Authentication error');
        this.setLoginFailed(true);
      }
    } catch (errorG) {
      const errorMessage = errorG instanceof Error ? errorG.message : credentialError;
      this.alertService.error(errorMessage, 'Authentication error');
      this.setLoginFailed(true);
    }

  }

  authLoginTrial(isGoogle: boolean): Promise<any> {
    return new Promise((resolve, reject) => {
      const provider = isGoogle ? new firebase.auth.GoogleAuthProvider() : new firebase.auth.OAuthProvider(firebaseProvider.Microsoft);
      provider.setCustomParameters({
        prompt: 'select_account',
      });
      this.afAuth.signInWithPopup(provider)
        .then((result) => {
          const user = result.user;
          if (!user || (user && user?.email?.includes('gmail.com'))) {
            this.afAuth.signOut().then(() => {
              this.alertService.error('Authentication by the selected email is not allowed. The trial requires a domain that has a workspace configured.', 'Invalid domain');
            });
            resolve(false);
          } else {
            this.setUserDataPromise(result.user).then((user) => {
              resolve(user);
            });
          }
        }).catch((error) => {
          this.showErrorMessage(error);
          resolve(false);
        });

    });
  }

signOut = (notRedirect?: boolean): Promise<void> => {
  const doSignOut = (skipRedirect?: boolean): Promise<void> => {
    return this.afAuth.signOut().then(() => {
      const loginRoute = this.getRedirectLoginRoute();
      this.signOutCallback();
      if (!skipRedirect) {
        window.location.replace(loginRoute);
      }
    });
  };

  if (this.nycAuthService.isNycSession && this.nycAuthService.pToken) {
    return new Promise<void>((resolve) => {
      this.nycAuthService.logout().then(() => {
        doSignOut(true).then(() => {
          resolve();
          this.nycAuthService.redirectToIdpLogout();
        });
      }).catch(() => {
        doSignOut(notRedirect).then(() => resolve());
      });
    });
  } else {
    return doSignOut(notRedirect);
  }
};

  //  Sign out
  signOutTrial = () => {
    return this.afAuth.signOut().then(() => {
      this.signOutCallback();
      void this.router.navigate(['/trial']).then(() => {
        window.location.reload();
      });
    });
  }

  // Sign out
  signOutRegister = (redirect: string) => {
    return this.afAuth.signOut().then(() => {
      this.signOutCallback();
      window.location.replace(redirect);
    });
  }

  getRedirectLoginRoute(): string {
    if (sessionStorage.getItem('nycAuth')) {
      return '/login-nyc';
    }
    // AVD-only sessions (Feature 92917) must return to the AVD login, not the generic
    // sign-in. Read here on purpose: this runs before signOutCallback() clears
    // sessionStorage. The flag is set only by the AVD login, so every other session
    // (GCP dashboard, etc.) keeps the generic /login unchanged.
    if (sessionStorage.getItem('microsoftAuthAVD') === 'true') {
      return '/login/avd';
    }
    return '/login';
  }

  private signOutCallback(): void {
    this.authChannel.postMessage({ type: 'LOGOUT' });
    sessionStorage.clear();
    this.sessionUserV2Service.clearSession();
    this.authCookiesServ.deleteAuth('user');
    this.matDialog.closeAll();
    if (this.authStateSubs) {
      this.authStateSubs.unsubscribe();
    }
    if (this.idTokenSubs) {
      this.idTokenSubs.unsubscribe();
    }
  }

  private signOutCallbackLocal(): void {
    sessionStorage.clear();
    this.authCookiesServ.deleteAuth('user');
    this.matDialog.closeAll();
    if (this.authStateSubs) {
      this.authStateSubs.unsubscribe();
    }
    if (this.idTokenSubs) {
      this.idTokenSubs.unsubscribe();
    }
  }

  authWithCustomTk(tk: string, redirectUrl: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const loginRoute = this.getRedirectLoginRoute();
      this.afAuth.signInWithCustomToken(tk)
        .then((userCredential) => {
          // Signed in
          const user = userCredential.user;
          // ...
          if (!user) {
            this.alertService.error('The specified token is not valid.', 'Invalid token');
            if (!redirectUrl) {
              this.router.navigate([loginRoute]);
            }
            resolve(false);
          } else {
            this.setUserDataPromise(user).then((user) => {
               const userLinked =  localStorage.getItem('userFirstLinking');
               const linked =  localStorage.getItem('linkedProvider');
               if(linked === firebaseProvider.Microsoft.toString() && userLinked ){
                  localStorage.removeItem('linkedProvider');
                  localStorage.removeItem('userFirstLinking');

                  if(userLinked === user?.email){
                      this.router.navigate(['/login'], {
                        queryParams: { 
                          provider: firebaseProvider.Microsoft,
                          linking: true
                        }
                      });
                  } else {                  
                     const userText = 'Please try again with the correct account for credential linking.';                         
                     this.alertService.warn(userText);
                     timer(3000).subscribe(()=>{
                        this.signOut();
                     });
                 
                  }               
                  resolve(false);
             } else {
                //this.userInfoService.updateUserInfoInBackground();
                 resolve(user);
                if (redirectUrl && redirectUrl.indexOf('dashboard') > -1) {
                  console.log('authWithCustomTk redirectUrl', redirectUrl);
                  this.router.navigate([redirectUrl]);
                }
             }
         
            });
          }
        })
        .catch((error) => {
          const errorMessage = error.message;
          this.alertService.error(errorMessage, 'Invalid token');
          if (!redirectUrl || redirectUrl !== 'dashboard') {
            this.router.navigate([loginRoute]);
          }
          resolve(false);
        });
    });
  }

  /**
  * Renews the Firebase ID token and refreshes the MSAL/Firebase session if needed.
  * Returns true if the renewal was successful, otherwise false.
  */
  async renewToken(): Promise<boolean> {
    try {
      const user = await this.afAuth.currentUser;

      if (user) {
        // Force-refresh Firebase ID token
        const tk = await user.getIdToken(true);

        const authMicrosoft = sessionStorage.getItem('microsoftAuth') === 'true';
        let fbCustomTk = '';
        if(authMicrosoft){
              // Check MSAL session and refresh Firebase custom token if available
              const accountsMsal = this.msalService.instance.getAllAccounts();

            // Get user auth in firebase
              const userAuthFirebase = this.sessionUserV2Service.userEmail;

              // Find the MSAL account that matches the Firebase user email
              const account = accountsMsal.find(acc => acc.username?.toLowerCase() === userAuthFirebase?.toLowerCase());

             
              if (accountsMsal.length > 0 && account) {
                const response = await this.msalService.instance.acquireTokenSilent({
                  scopes: loginRequest.scopes,
                  account: account
                });

                const newIdToken = response.idToken;

                // Exchange MSAL ID token for a new Firebase custom token
                fbCustomTk = await this.cookieTkService
                  .getFbCustomTkByMsalIdTk(newIdToken)
                  .toPromise();
              }
        }
      
        // Update application cookies/session with new tokens
        const success = await this.setUserDataPromise(user, tk, fbCustomTk);

        if (success) {
          // Notify other tabs that the token was updated
          this.authChannel.postMessage({ type: 'TOKEN_UPDATED', token: tk });
        }

        return success;

      } else {
        // No Firebase user logged in
        return false;
      }
    } catch (error) {
      console.error("Error renewing token:", error);
      return false;
    }
  }


  signInUserAndPassword(email: string, password: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.afAuth.signInWithEmailAndPassword(email, password)
        .then((userCredential) => {
          const user = userCredential.user;
          if (user !== null) {
            user.getIdToken(true).then(id => {
              resolve({
                token: id,
                user: user
              });
            });
          }
        })
        .catch((error) => {
          resolve(false);
        });
    });
  }

  setLoginFailed(loginFailed: boolean): void {
    this.loginFailed$.next(loginFailed);
  }
  setToken(token: string | null): void {
    this.authToken$.next(token?.toString());
  }
  setUser(user: any): void {
    this.authUser$.next(user);
  }
  getUserFromStorage(): any {
    const u = sessionStorage.getItem('user');
    return u ? JSON.parse(sessionStorage.getItem('user') as string) : {};
  }

  getProviderFromStorage(): any {
    const provider = sessionStorage.getItem('currentProvider');
    return provider;
  }

  getCurrentDistrictFromStorage(): any {
    const d = sessionStorage.getItem('UserDistrictSelected');
    return d ? JSON.parse(sessionStorage.getItem('UserDistrictSelected') as string) : {};
  }

  setLastDistrict(districtId: string): void {
    sessionStorage.setItem('lastDistrict', districtId);
  }

  setDistrictSchool(districtId: string): void {
    sessionStorage.setItem('districtSchool', districtId);
  }

  getLastDistrictId(): string {
    return sessionStorage.getItem('lastDistrict') as string;
  }

  getLastDistrict(): DistrictShort | undefined {
    const district = sessionStorage.getItem('lastDistrict');
    const districts = this.getDistricts();
    return districts.find((dist) => dist.districtId === district);
  }
  getSchoolbyLastDistrict(): any {
    const schoolId = this.getLastSchool();
    const lastDistrict = this.getLastDistrict();
    return lastDistrict?.schools?.find((sch) => sch?.schoolId === schoolId);
  }

  getDistricts(): DistrictShort[] {
    const districts = sessionStorage.getItem('districts');
    if (districts) {
      return JSON.parse(districts);
    } else {
      return [];
    }
  }
  getLastSchool(): string | null {
    return sessionStorage.getItem('lastSchool');
  }

  // Sign in with popup mechanism
  authPopUp = (provider: any) => {
    provider.setCustomParameters({
      prompt: 'select_account'
    });
    return this.authLoginPromisePopUp(provider);
  }

  authLoginPromisePopUp = (provider: any): Promise<boolean> => {
    return new Promise((resolve) => {
      provider.setCustomParameters({
        prompt: 'select_account'
      });
      return this.afAuth.signInWithPopup(provider)
        .then((result) => {
          this.setUserDataPromise(result.user).then((value: boolean) => {
            resolve(value);
          });
        }).catch((error) => {
          resolve(false);
          this.showErrorMessage(error);
        });
    });
  }

  startRefreshTokenTimer() {
    try {
      // Asegurarse de que haya un token válido antes de continuar
      if (!this.token) {
        console.warn('No token available to start refresh timer');
        return;
      }

      // Detener cualquier worker anterior antes de iniciar uno nuevo
      this.stopRefreshTokenTimer();

      const decodedToken: any = jose.decodeJwt(this.token);
      const expires = new Date(decodedToken.exp * 1000);
      console.log(expires);
      /* console.log(new Date(expires ? expires * 1000 : '').toLocaleString()); */
      let timeout = expires.getTime() - Date.now() - 300 * 1000;

      const MAX_TIMEOUT = 2147483647; // ~24.8 días

      if (timeout <= 0) {
        console.warn('Token is already expired or about to expire, refreshing immediately');
        this.renewToken();
        return;
      }

      if (timeout > MAX_TIMEOUT) {
        console.log(`Token expiration too far in future (${Math.round(timeout / (1000 * 60 * 60 * 24))} days), capping refresh timer to ${Math.round(MAX_TIMEOUT / (1000 * 60 * 60 * 24))} days`);
        timeout = MAX_TIMEOUT;
      }

      this.refreshTokenWorker = new Worker('/assets/timer/refresh-token-worker.js');
      this.refreshTokenWorker.postMessage(timeout);

      this.refreshTokenWorker.onmessage = (event) => {
        if (event.data === 'WORKER_READY') {
          console.log('⏱️', new Date().toLocaleTimeString());
        } else {
          console.log('🔁', new Date().toLocaleTimeString());
          this.renewToken();
        }
      };
    } catch (error) {
      console.error('Error al iniciar el temporizador de renovación del token:', error);
      this.signOut();
    }
  }

  private stopRefreshTokenTimer() {
    if (this.refreshTokenWorker) {
      this.refreshTokenWorker.terminate();
      this.refreshTokenWorker = null!;
    }
  }

  private checkIfLeader() {
    this.leaderCheckInterval = setInterval(() => {
      const now = Date.now();
      const leaderTimestamp = parseInt(localStorage.getItem(this.LEADER_KEY) || '0', 10);
      const checkToken = this.router.url !== "/login";

      if (isNaN(leaderTimestamp) || now - leaderTimestamp > 10000) {
        localStorage.setItem(this.LEADER_KEY, now.toString());
        if (this.refreshTokenWorker) return;

        // Schedule the refresh from the current token's expiry instead of forcing a new token on every
        // page load: a forced refresh changes the token and makes the iStreamer client reconnect.
        // startRefreshTokenTimer still renews right away when the token is about to expire.
        if(checkToken){
          this.startRefreshTokenTimer();
        }
      
      }
    }, 5000);
  }

  private listenBroadcastChannel() {
    this.authChannel.onmessage = (event) => {
      const data = event.data;

      if (!data?.type) return;

      if (data.type === 'LOGOUT') {
        this.signOutCallbackLocal();
      }

      if (data.type === 'TOKEN_UPDATED' && data.token) {
        this.token = data.token;
        this.tokenSubject.next(data.token);
        this.setToken(data.token);
        this.cookieTkService.setCookie(data.token).subscribe();
      }
    };
  }
}
